module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMTAgMEM0LjQ4NjA2IDAgMCA0LjQ4NjA2IDAgMTBDMCAxNS41MTM5IDQuNDg2MDYgMjAgMTAgMjBDMTUuNTEzOSAyMCAyMCAxNS41MTM5IDIwIDEwQzIwIDQuNDg2MDYgMTUuNTEzOSAwIDEwIDBaTTE0LjUgMTMuNUwxMy41IDE0LjVMMTAgMTFMNi41IDE0LjVMNS41IDEzLjVMOSAxMEw1LjUgNi41TDYuNSA1LjVMMTAgOUwxMy41IDUuNUwxNC41IDYuNUwxMSAxMEwxNC41IDEzLjVaIiBmaWxsPSIjRjQ0MzM2Ii8+Cjwvc3ZnPgoK"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-check-invalid.svg
// module id = 8e/P
// module chunks = 1